import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import { CombinedLangContractContext } from '../../../components/contexts/ProviderLangContractContext';

export default class RedirectComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            token:
                typeof this.props.match.params.token == 'undefined' || this.props.match.params.token == null
                    ? null
                    : this.props.match.params.token,
            clientId:
                typeof this.props.match.params.clientId == 'undefined' || this.props.match.params.clientId == null
                    ? null
                    : this.props.match.params.clientId,
            isPaymentCallback:
                typeof this.props.match.params.paymentMode == 'undefined' || this.props.match.params.paymentMode == null
                    ? false
                    : this.props.match.params.paymentMode?.toLowerCase() === 'authentication'
        };
    }

    componentDidMount() {
        fetch(
            'api/claim/ClaimNumberSearch/'
                + this.state.token
                + '/'
                + this.state.clientId
                + '/'
                + this.state.isPaymentCallback
        )
            .then((res) => res.json())
            .then(
                (data) => {
                    console.log(data);
                    const language = data?.languageCode?.toLowerCase();
                    sessionStorage.setItem('country', data?.countryCode?.toUpperCase());
                    this.context?.languageContext?.updateCountry(data?.countryCode?.toUpperCase(), language);
                    this.context?.contractContext?.setLoggedIn(true);

                    this.props.history.push('/vendor/apple/payment', {
                        entitlementDetails: {
                            clientId: this.state.clientId,
                            caseNumber: data.caseNumber,
                            partyId: data.party.partyId,
                            partyStatusId: data.party.partyStatusId,
                            firstName: data.party.firstName,
                            lastName: data.party.lastName,
                            partyName: data.party.firstName + ' ' + data.party.lastName,
                            partyAddressModel: data.party.partyAddressModel,
                            partyPhoneModel: data.party.partyPhoneModel,
                            partyEmailModel: data.party.partyEmailModel,
                            contract: data.contract,
                            contractAsset: data.contractAsset,
                            claimId: data.claim.claimId,
                            claimNumber: data.claim.claimNumber,
                            party: data.party,
                            deductible: data.deductible,
                            incidentDescription: data.claim.incidentDescription,
                            incidentDate:
                                data.claim.incidentDate === undefined ? data.claim.lossDate : data.claim.incidentDate,
                            claimSetupDate: data.claim.claimSetupDate,
                            coverageId: data.coverageId,
                            mailingAddress: data.party.billingAddress.address1,
                            mailingAddress2: data.party.billingAddress.address2,
                            city: data.party.billingAddress.city,
                            state: data.party.billingAddress.state,
                            stateId: data.party.billingAddress.stateId,
                            zip: data.party.billingAddress.zip,
                            contactPhone: data.party.partyPhoneModel.find((pp) => (pp.phoneType = 2)).number,
                            email: data.party.partyEmailModel[0].address,
                            countryCode: data.countryCode ?? 'us',
                            shipToCountryCode: data.shipToCountryCode,
                            isPaymentCallback: this.state.isPaymentCallback,
                            paymentCallbackResponse: data.paymentCallbackResponse
                        },
                        claim: data.claim
                    });
                },
                (error) => {
                    console.error(error);
                    this.props.history.push('/vendor/apple/', {});
                }
            );
    }

    render() {
        return (
            <Container className='pageLoading'>
                <div className='centeredXY text-center'>
                    <Spinner
                        animation='border'
                        variant='primary'
                        role='status'
                    />
                    <p>Loading...</p>
                </div>
            </Container>
        );
    }
}

RedirectComponent.contextType = CombinedLangContractContext;
